import tlh from 'api/tlh'
import { toast } from 'react-toastify'

export const openDocument = (url, fileName) => {
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.download = fileName
    link.click()
}

export const downloadDocuments = (value, type, idToken, t) => {
    const toastId = toast(t('tlh.download'))
    tlh.downloadDocument(value)
        .then(response => {
            if (response.data) {
                if (response.data.body) {
                    openDocument(response.data.body, type)
                } else {
                    openDocument(response.data, type)
                }
            } else {
                toast.dismiss(toastId);
                toast.error(t('tlh.errors.file.notFound'));
            }
        })
        .catch(error => {
            console.error(error);
            toast.dismiss(toastId);
            toast.error(t('tlh.noReport'));
        })
}
